<template>
  <div>
    <b>General description</b>
    <br />
    The RAAN phasing mission allows to simultaneously perform a specified change
    in mean semi-major axis, inclination as well as relative RAAN with respect
    to a given reference. This can be either the trajectory of a spacecraft
    performing an orbital transfer from the initial to the final orbits or a
    specified target orbit (see the <i> RAAN phasing reference</i> tooltip
    below).
    <br />
    <br />
    This mission provides a means of distributing spacecrafts over several
    orbital planes during the deployment of a constellation. Since it can be
    very time and fuel consuming an optimisation is performed (see below). This
    mission is computed accounting for the secular effect of the zonal harmonics
    <katex-element expression="J_2" />. The effect of atmospheric drag can be
    optionally considered.
    <br />
    <br />
    <b>Manoeuvre strategy</b>
    <br />
    The idea of the mission is to exploit the RAAN drift rate caused by the
    <katex-element expression="J_2" />
    term of the Earth potential.
    <br />
    The spacecraft manoeuvres from an initial orbit to a coasting orbit. After a
    while, a second manoeuvre is performed from the coasting orbit to a final
    orbit, which may or may not be different from the initial orbit. The target
    value for the relative RAAN change
    <katex-element expression="\Delta\Omega" />
    with respect to the chosen reference trajectory is built-up by the
    difference in RAAN drift rate during the mission.
    <br />
    <br />
    <b>Coasting orbit computation</b>
    <br />
    The coasting semi-major axis, inclination as well as the coasting duration
    are computed by iterative optimisation. This is done using an analytical
    model for the manoeuvre which guarantees fast computation. The performance
    index to be optimised can be one of:
    <br />
    <br />
    <ul>
      <li>
        <katex-element expression="\Delta V" />: the fuel consumption to achieve
        a given <katex-element expression="\Delta\Omega" /> is minimised for a
        user-specified mission duration.
      </li>
      <li>
        <katex-element expression="\Delta T" />: manoeuvre time to achieve a
        given <katex-element expression="\Delta\Omega" /> is minimised for a
        user-specified maximum <katex-element expression="\Delta V" /> value.
      </li>
      <li>
        <katex-element expression="\Delta \Omega" />: the RAAN variation is
        maximised for a user-specified maximum
        <katex-element expression="\Delta V" /> value.
      </li>
    </ul>
    <br />
    <b>Taking into account the atmospheric drag</b>
    <br />
    When the atmospheric drag is simulated, it is assumed that the spacecraft
    performs regular station keeping manoeuvres in order to consider coasting as
    taking place at constant altitude. The impact of the station keeping phase
    on the manoeuvre <katex-element expression="\Delta V" /> is taken into
    account.
    <br />
    <br />
    The atmosphere model considered is the tabulated US76, which is used to
    compute the atmospheric density between 0 and 1000 km.
    <br />
    <br />
  </div>
</template>

<script>
export default {
  name: 'tooltipParametricRAANPhasing'
}
</script>
